var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13973 18.3993L7.89339 18.1238L0.698895 10.0779L0.472656 9.82489L0.698895 9.57187L7.89339 1.52597L8.13973 1.25049L8.38607 1.52597L9.68048 2.97356L9.90672 3.22658L9.68048 3.47959L5.23669 8.44927H19.3177H19.6589V8.81494V10.8348V11.2005H19.3177H5.23669L9.68048 16.1702L9.90672 16.4232L9.68048 16.6762L8.38607 18.1238L8.13973 18.3993Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13964 17.871L9.43405 16.4234L4.43703 10.835H19.3176V8.81512H4.43703L9.43405 3.22676L8.13964 1.77917L0.945148 9.82507L8.13964 17.871ZM8.13964 18.928L0 9.82507L8.13964 0.722168L10.3792 3.22676L6.03614 8.08377H20V11.5664H6.03614L10.3792 16.4234L8.13964 18.928Z",
    fill: "#475467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/BackArrowIcon.af60ac99d2e9fbbea147a5f3dfa0edc5.svg";
export { ForwardRef as ReactComponent };